/**
 * Product Info Carousel — deferred interactions (async)
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

// Deferred execution - won't block page load
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantitySelector);
  } else {
    initQuantitySelector();
  }
  
  function initQuantitySelector() {
    const wrapper = document.querySelector('.product-info-carousel');
    if (!wrapper) return;
  
    wrapper.addEventListener('click', function(e) {
      if (e.target.closest('.product-info-carousel__quantity-btn')) {
        const btn = e.target.closest('.product-info-carousel__quantity-btn');
        const selector = btn.closest('.product-info-carousel__quantity-selector');
        const input = selector.querySelector('.product-info-carousel__quantity-input');
        const isPlus = btn.getAttribute('name') === 'plus';
        let val = parseInt(input.value);
        
        if (isPlus) {
          val++;
        } else {
          if (val > 1) val--;
        }
        
        input.value = val;
      }
    });
  }
})();

  function initAccordions() {
    const carouselRoot = document.querySelector('.product-info-carousel');
    const guard = carouselRoot || document.documentElement;
    if (guard.dataset.accordionsInitialized === 'true') return;

    document.addEventListener('click', function (e) {
      const header = e.target.closest('.product-info-carousel__accordion-header');
      if (!header) return;

      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const content = document.getElementById(header.getAttribute('aria-controls'));
      if (!content) return;

      document.querySelectorAll('.product-info-carousel__accordion-header').forEach(function (h) {
        if (h !== header) {
          h.setAttribute('aria-expanded', 'false');
          const c = document.getElementById(h.getAttribute('aria-controls'));
          if (c) c.style.maxHeight = null;
        }
      });

      header.setAttribute('aria-expanded', String(!isExpanded));
      content.style.maxHeight = isExpanded ? null : content.scrollHeight + 'px';
    });

    guard.dataset.accordionsInitialized = 'true';
  }

  onReady(function () {
    function initAccordionsLazy() {
      initAccordions();
    }

    function initOnInteraction() {
      initAccordionsLazy();
      document.removeEventListener('click', initOnInteraction);
      document.removeEventListener('scroll', initOnInteraction);
      document.removeEventListener('keydown', initOnInteraction);
    }

    document.addEventListener('click', initOnInteraction, { once: true });
    document.addEventListener('scroll', initOnInteraction, { once: true });
    document.addEventListener('keydown', initOnInteraction, { once: true });
    setTimeout(initAccordionsLazy, 5000);
  });
})();
